import { render, staticRenderFns } from "./NgeniusPaymentGateway.vue?vue&type=template&id=6dfc0178&scoped=true&"
import script from "./NgeniusPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./NgeniusPaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./NgeniusPaymentGateway.vue?vue&type=style&index=0&id=6dfc0178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc0178",
  null
  
)

export default component.exports